import React from "react";
import { useLocation } from "react-router-dom";
import { Result } from "antd";
import queryString from "query-string";

export const AuthError = () => {
  const location = useLocation();
  const parsed = queryString.parse(location.search);
  const { message, errorId } = parsed;
  return (
    <div>
      <Result
        status={500}
        title={message ? message : "Something went wrong"}
        subTitle={`Try again, if error persists, please report to software developer. Error Id=${errorId}`}
      />
    </div>
  );
};
